import { Component } from "react";

export default class Logout extends Component {
    constructor(props) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('restrictedPath');
        window.location.href= '/';
    }
}
